import fpgConfiguration from '@/store/fpgConfiguration';

export function gatewayInterceptor(config) {
  let isTileMode = fpgConfiguration.state.isTileMode;
  if (isTileMode) {
    config.baseURL = '/fleet-account' + config.baseURL;
  }
  return config;
}
